import React from 'react';
import {Card, Col, ConfigProvider, Flex, Layout, List, Row} from "antd";
import {t} from "i18next";
import LayoutSider from "../../components/brief/LayoutSider";
import Title from "antd/es/typography/Title";
import IconBackArrow from "../../components/ui/icons/IconBackArrow";
import {Link} from "react-router-dom";
import AdminPanel from "./AdminPanel";

const {Header, Content, Sider} = Layout

export default function Admin() {
  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            headerBg: '#fff',
            siderBg: '#fff',
            fontFamily: 'Open Sans',
            fontFamilyCode: 'Open Sans',
          },
        },
      }}
    >
      <Layout>
        <Header className={'layout-header'}>
          <Row justify={"space-between"} style={{flex: 1}} align={"middle"}>
            <Col span={8}>
              <Link to={{pathname: '/briefs/actual',}} style={{display: 'flex', gap: '16px'}}>
                <Flex gap={'small'} align={'center'}>
                  <IconBackArrow/>
                </Flex>
              </Link>
            </Col>
            <Col span={8}>
              <Flex justify={'center'}><Title level={5} style={{margin: 0}}>{t('admin.title')}</Title></Flex>
            </Col>
            <Col span={8}></Col>
          </Row>
        </Header>
        <Layout style={{paddingLeft: '48px'}}>
          <LayoutSider/>
          <Layout>
            <Content
              style={{
                minHeight: 'calc(100vh - 96px)',
                background: '#F1F5F7',
                padding: '16px',
              }}
            >
              <Flex gap={'small'}>
                <Card style={{width: '100%'}}>
                  <AdminPanel/>
                </Card>
              </Flex>
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </ConfigProvider>
  )
}
